import { Controller } from 'react-hook-form'

import { useFormContextContact } from '../_utils'
import ContactFormField from '../ContactFormField'

const SecuredEmail = () => {
    const { control, watch } = useFormContextContact()
    const rppsNum = watch('rppsNum')
    const noSecureEmailText = 'Aucun courriel sécurisé'

    return (
        <Controller
            control={control}
            name="securedEmail"
            render={({ field, fieldState: { error } }) => (
                <ContactFormField
                    variant="input"
                    label="Courriel sécurisé"
                    disabled
                    noValueText={rppsNum ? noSecureEmailText : undefined}
                    status={{
                        error,
                        valid: Boolean(field.value) || Boolean(!field.value && rppsNum),
                    }}
                    size="0.5"
                    dataCyScope="ContactField"
                    {...field}
                    onChange={(e) => {
                        field.onChange(e)
                    }}
                    value={field.value ?? ''}
                    placeholder="Courriel sécurisé"
                />
            )}
        />
    )
}

export default SecuredEmail
